/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_Existing_Confirm_ActionInputs */

const en_task_requested_documents_existing_confirm_action = /** @type {(inputs: Task_Requested_Documents_Existing_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request anyway`)
};

const pt_br2_task_requested_documents_existing_confirm_action = /** @type {(inputs: Task_Requested_Documents_Existing_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar solicitação`)
};

/**
* | output |
* | --- |
* | "Request anyway" |
*
* @param {Task_Requested_Documents_Existing_Confirm_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_existing_confirm_action = /** @type {((inputs?: Task_Requested_Documents_Existing_Confirm_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_Existing_Confirm_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_existing_confirm_action(inputs)
	return pt_br2_task_requested_documents_existing_confirm_action(inputs)
});